<template>
  <div
    v-if="showRecommendedLess"
    class="text-center"
    data-test="recommended-less"
  >
    <div>「本日のおすすめ」は、各求人のマッチング条件と女の転職type会員の行動をもとにした、貴社へのスカウトおすすめ会員です。</div>
    <div>表示されない場合は、マッチング条件の変更などを制作担当者へご相談ください。</div>
  </div>
</template>

<script>
export default {
  props: {
    showRecommendedLess: {
      type: Boolean,
      required: true
    }
  }
}
</script>
